module.exports = __webpack_public_path__ + "static/img/ttr08.fe01deb.png";